import { useState } from "react";
import UploadedDocumentsModal from "./UploadedDocumentsModal";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const UploadedDocumentsModalAndButton = (props: {
  uploadedDocumentsNumber: number;
  cargoId: string;
}) => {
  const { t } = useTranslation("stopPage");
  const { uploadedDocumentsNumber, cargoId } = props;
  const [showAddNoteDialog, setShowAddNoteDialog] = useState(false);

  return (
    <>
      {showAddNoteDialog && (
        <UploadedDocumentsModal
          cargoId={cargoId}
          onClose={() => setShowAddNoteDialog(false)}
        />
      )}
      <Button
        onClick={() => setShowAddNoteDialog(true)}
        variant="outlined"
        size="large"
      >
        {t("uploadedDocuments")}{" "}
        {uploadedDocumentsNumber ? `(${uploadedDocumentsNumber})` : ""}
      </Button>
    </>
  );
};

export default UploadedDocumentsModalAndButton;
